import { render, staticRenderFns } from "./PrintPreviewOld.vue?vue&type=template&id=3c332e28&scoped=true"
import script from "./PrintPreviewOld.vue?vue&type=script&lang=js"
export * from "./PrintPreviewOld.vue?vue&type=script&lang=js"
import style0 from "./PrintPreviewOld.vue?vue&type=style&index=0&id=3c332e28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c332e28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c332e28')) {
      api.createRecord('3c332e28', component.options)
    } else {
      api.reload('3c332e28', component.options)
    }
    module.hot.accept("./PrintPreviewOld.vue?vue&type=template&id=3c332e28&scoped=true", function () {
      api.rerender('3c332e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printpreview/PrintPreviewOld.vue"
export default component.exports